module.exports = __webpack_public_path__ + "img/amanda-ava.c7bd7a7.png";